export default {
    title: '<strong>老师</strong>和<strong>学生</strong>共同参与的<strong>实时课堂活动</strong>',
    buttons: {
        teacher: '老师开始上课',
        student: '学生进入',
    },
};
